import React from 'react';
import TpJobAdmin from '../../Operations/TpJob/TpJobAdmin';
import EvaluatorAssignmentAdmin from '../../Operations/Assignments/EvaluatorAssignmentAdmin';

// The window is opened from two different grids - the TP Evaluator list and the TpEvaluator
// Profiles list embedded in an evaluator row's detail popup - so the selected item has to arrive
// as data (GenericOverWindow's filterParameters prop). It used to be read from a mutable static
// that both admin components overwrote in their constructors, so whichever mounted last answered
// for both: after opening the TpEvaluator Profiles tab once, the evaluator grid's Jobs action
// read the other component's empty selection and showed "undefined" over an unfiltered job list.
export default class RelatedTpJobWindowDescription {
  static getTitle(filterParameters) {
    const name = filterParameters?.name ?? '';
    const tpEvaluatorId = filterParameters?.tpEvaluatorId;
    // Opened from the profiles grid there is no evaluator id to show, so the whole suffix is
    // dropped instead of printing an empty one.
    return tpEvaluatorId
      ? `Related Jobs - ${name} (Bravo TP Evaluator ID: ${tpEvaluatorId})`
      : `Related Jobs - ${name}`;
  }

  static getTabs(filterParameters) {
    return [
      {
        label: 'Related Jobs',
        id: 'jobs_tab',
        icon: 'fa-solid fa-briefcase',
        component: (
          <TpJobAdmin
            tpEvaluatorId={filterParameters?.tpEvaluatorId}
            tpEvaluatorLinkId={filterParameters?.tpEvaluatorLinkId}
          />
        ),
      },
      {
        label: 'Related Assignments',
        id: 'assignments_tab',
        icon: 'fa-solid fa-briefcase',
        component: <EvaluatorAssignmentAdmin evaluatorId={filterParameters?.evaluatorId} />,
      },
    ];
  }
}
